import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "content-view"
};
import { onMounted, ref } from "vue";
import { request } from '@/manager/net_manager';
import router from '@/router';
import DramaDetail from "@/components/Drama/DramaDetail.vue";
import { pageStyle } from "@/theme/sliderStyle"; // refs

export default {
  __name: 'DramaDetailPage',

  setup(__props) {
    const dramaId = ref(null);
    const drama = ref(null); // functions

    const getData = () => {
      let parameters = {
        'drama_id': dramaId.value
      };
      request('drama/get/', parameters, 'POST').then(response => {
        // console.log(JSON.stringify(response))
        if (response.code === 0) {
          drama.value = response.data;
        }
      });
    }; // lifecycle


    onMounted(() => {
      dramaId.value = router.currentRoute.value.params.dramaId;
      getData();
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        id: "page-container",
        style: _normalizeStyle(_unref(pageStyle))
      }, [_createElementVNode("div", _hoisted_1, [dramaId.value ? (_openBlock(), _createBlock(DramaDetail, {
        key: 0,
        "drama-id": dramaId.value
      }, null, 8, ["drama-id"])) : _createCommentVNode("", true)])], 4);
    };
  }

};